import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { getCurrencySign, shouldTranslateTo } from '../../utils/utils'
import { gaEvents } from '../../analytics/events'
import styled from 'styled-components'
import Error from '../Utils/Error'

import {
  Title,
  Subtitle,
  CustomSubtitle,
  Input,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 0 0 80px;
  background-color: transparent;

  @media (max-width: 799px) {
    padding: 25px 25px 25px 25px;
  }
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const DashLineBox = styled.div`
  margin: 40px 10vw;
  padding: 30px 50px 40px;
  border-radius: 4px;
  border: 2px dashed #0bac5d;

  @media screen and (max-width: 799px) {
    padding: 30px 5vw 40px;
    margin: 30px 0 40px;
  }
`

const AccountDetailsRow = styled.div`
  padding: 10px 0 0;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`

const BreakSub = styled(Subtitle)`
  display: flex;
  overflow-wrap: anywhere;
`

const ErrorWrapper = styled.div`
  margin: 20px 0 0 0;
`

const Verified = styled.div`
  ${(props) => props.color && `background-color: ${props.color}`};
  border-radius: 30px;
  padding: 0px 12px;
  color: #fff;
  height: 21px;

  display: flex;
  margin: 6px 0 0 7px;

  @media screen and (max-width: 799px) {
    margin: 3px 0 0 7px;
  }
`

const VerifiedImage = styled.img`
  width: 20px;
  height: 20px;
  margin: 1px 3px 0 -2px;
`

const VerifiedSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin: 1px 0 0 0;
`

const AccountSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  font-weight: 400;
  margin: 0 0 0 20px;
`

const ButtonsRow = styled.div`
  padding: 10px 0 0;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`

const AccountButton = styled(ActionButtons)`
  background-color: rgb(235, 94, 85);
`

const ManageAccount = ({ data, onUpdate }) => {
  const [cancelStep, setCancelStep] = useState('')
  const [error, setError] = useState('')
  const [pageText, setPageText] = useState([])
  const [subscriptionType, setSubscriptionType] = useState('')
  const [membershipFee, setMembershipFee] = useState('')

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'manage-account-page-loaded',
      data.auth.user.id + ' - manage account - page loaded'
    )

    setSubscriptionType(
      data.auth.user.subscriptionType === 'freemium' ||
        data.auth.user.subscriptionType === null
        ? 'Visitor'
        : data.auth.user.subscriptionType
    )

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setMembershipFee(currencySignData.sign + data.auth.user.membershipFee)
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getCurrency()
    getPageText('profile-account', language)
  }, [])

  const cancelAccount = (e, value) => {
    e.preventDefault()
    console.log('value: ' + value)

    value === 'step2' && ActionCancellation()
    value === 'step3' && onUpdate()

    setCancelStep(value)
  }

  const ActionCancellation = () => {
    const memberData = {
      id: data.auth.user.id,
    }

    console.log('memberData: ' + JSON.stringify(memberData))

    const headers = {
      'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    }

    axios
      .post('/api/cancellation-request', memberData, headers)
      .then((response) => {
        console.log('response: ' + response)
      })
      .catch((e) => {
        console.log('error: ' + e)
      })
  }

  if (pageText.length === 0 || subscriptionType === '') {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[0]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <OnboardingTitle
        center
        color="#ff9900"
        size="34px"
        sizemd="34px"
        sizesm="34px"
        margin="10px 0 0"
        dangerouslySetInnerHTML={{
          __html: `${pageText[1]}`,
        }}
      ></OnboardingTitle>

      <OnboardingSubtitle
        color="#fff"
        center
        size="20px"
        sizesm="20px"
        weight="700"
        margin="10px 0 30px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[2]}`,
        }}
      ></OnboardingSubtitle>

      <DashLineBox>
        <AccountDetailsRow>
          <BreakSub color="#fff" size="22px" bold>
            {pageText[3]}
          </BreakSub>
          <Verified color="#0da078">
            <VerifiedImage
              src={'/images/profile/icon-verified-plain.svg'}
              alt="verified"
            />
            <VerifiedSubtitle
              color="#fff"
              size="16px"
              sizemd="16px"
              sizesm="16px"
              margin="4px 0 0 4px"
              dangerouslySetInnerHTML={{
                __html: `${subscriptionType}`,
              }}
            />
          </Verified>
        </AccountDetailsRow>

        <AccountDetailsRow>
          <BreakSub color="#fff" size="22px" bold>
            {pageText[4]}
          </BreakSub>
          <AccountSubtitle
            color="#fff"
            size="20px"
            sizemd="20px"
            sizesm="20px"
            margin="1px 0 0"
            dangerouslySetInnerHTML={{
              __html: `${membershipFee}`,
            }}
          />
        </AccountDetailsRow>

        {cancelStep === 'step2' ? (
          <>
            <OnboardingSubtitle
              color="#fff"
              size="20px"
              sizesm="20px"
              weight="400"
              margin="20px 0 5px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[5]}`,
              }}
            ></OnboardingSubtitle>
            <AccountButton
              type="submit"
              padding="10px 50px"
              margin="30px 0 0 0"
              onClick={(e) => cancelAccount(e, 'step3')}
            >
              {pageText[10]}
            </AccountButton>
          </>
        ) : cancelStep === 'step1' ? (
          <>
            <OnboardingSubtitle
              color="#fff"
              size="20px"
              sizesm="20px"
              weight="400"
              margin="20px 0 5px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[6]}`,
              }}
            ></OnboardingSubtitle>
            <ButtonsRow>
              <ActionButtons
                type="submit"
                padding="10px 50px"
                margin="0"
                onClick={(e) => cancelAccount(e, '')}
              >
                {pageText[7]}
              </ActionButtons>

              <AccountButton
                type="submit"
                padding="10px 50px"
                margin="0"
                onClick={(e) => cancelAccount(e, 'step2')}
              >
                {pageText[8]}
              </AccountButton>
            </ButtonsRow>
          </>
        ) : cancelStep === '' ? (
          <AccountButton
            type="submit"
            padding="10px 50px"
            margin="40px 0 0 0"
            onClick={(e) => cancelAccount(e, 'step1')}
          >
            {pageText[9]}
          </AccountButton>
        ) : null}

        <ErrorWrapper>{error && <Error error={error} />} </ErrorWrapper>
      </DashLineBox>
    </ContainerBox>
  )
}

export default withRouter(withAuth(ManageAccount))
